import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../../../utils/propUtils';
var VeltCommentDialogVisibilityBannerDropdownContentUserPickerItemAvatar = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-visibility-banner-dropdown-content-user-picker-item-avatar-wireframe", __assign({}, transformedProps), children));
};
export default VeltCommentDialogVisibilityBannerDropdownContentUserPickerItemAvatar;
